import { SelectChangeEvent } from '@mui/material'
import { DateTime } from 'luxon'
import { useState } from 'react'
import BarChartOutlinedIcon from '@mui/icons-material/BarChartOutlined'
import { MetricsFieldName } from '~/generated/graphql'
import { DateRangePickerContainer } from '~/components/common/DateRangePickerContainer'
import { MetricDataGridProWithTabPanel } from './MetricDataGridProWithTabPanel'
import { AdvAccountMetricsChart } from './AdvAccountMetricsChart'
import { MetricSelectGroup } from './MetricSelectGroup'
import { SectionCardContainer } from '~/components/common/SectionCardContainer'

export const metrics = {
  表示回数: MetricsFieldName.Impression,
  リーチ数: MetricsFieldName.Reach,
  エンゲージメント数: MetricsFieldName.Engagement,
  エンゲージメント率: MetricsFieldName.EngagementRate,
  いいね数: MetricsFieldName.Like,
  コメント数: MetricsFieldName.Comment,
  保存数: MetricsFieldName.Save,
  シェア数: MetricsFieldName.Share,
} as const

export type MetricsKey = keyof typeof metrics
export type MetricType = typeof metrics

export const CampaignInsight = () => {
  const [startDate, setStartDate] = useState<string>(DateTime.now().minus({ days: 30 }).toISODate())
  const [endDate, setEndDate] = useState<string>(DateTime.now().toISODate())

  const [firstMetric, setFirstMetric] = useState<MetricsKey>('表示回数')
  const [secondMetric, setSecondMetric] = useState<MetricsKey>('リーチ数')

  const [haveCustomized, setHaveCustomized] = useState(false)

  const handleStartDateChange = (date: DateTime | null) => {
    setHaveCustomized(true)
    if (date) {
      setStartDate(date.toISODate()!)
    }
  }
  const handleEndDateChange = (date: DateTime | null) => {
    setHaveCustomized(true)
    if (date) {
      setEndDate(date.toISODate()!)
    }
  }

  const handleFirstMetricChange = (e: SelectChangeEvent) => {
    setHaveCustomized(true)
    setFirstMetric(e.target.value as MetricsKey)
  }

  const handleSecondMetricChange = (e: SelectChangeEvent) => {
    setHaveCustomized(true)
    setSecondMetric(e.target.value as MetricsKey)
  }

  return (
    <SectionCardContainer
      title="キャンペーンインサイト"
      icon={<BarChartOutlinedIcon sx={{ fontSize: 24, color: 'black' }} />}
    >
      <DateRangePickerContainer
        titleComponent={
          <MetricSelectGroup
            firstMetric={firstMetric}
            secondMetric={secondMetric}
            metrics={metrics}
            handleFirstMetricChange={handleFirstMetricChange}
            handleSecondMetricChange={handleSecondMetricChange}
          />
        }
        startDate={startDate}
        endDate={endDate}
        handleStartDateChange={handleStartDateChange}
        handleEndDateChange={handleEndDateChange}
      >
        <AdvAccountMetricsChart
          metrics={metrics}
          firstMetric={firstMetric}
          secondMetric={secondMetric}
          startDate={startDate}
          endDate={endDate}
          haveCustomized={haveCustomized}
        />

        <MetricDataGridProWithTabPanel startDate={startDate} endDate={endDate} />
      </DateRangePickerContainer>
    </SectionCardContainer>
  )
}
